"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLegacyRpcSdk = buildLegacyRpcSdk;
const method_handler_factory_1 = require("./method-handler-factory");
function buildLegacyRpcSdk(options) {
    const LegacyRpcSdk = new Proxy({}, {
        get: (_, service) => new Proxy({}, {
            get: (__, method) => (0, method_handler_factory_1.methodHandlerFactory)({
                service,
                method,
                ...options,
            }),
        }),
    });
    return LegacyRpcSdk;
}
//# sourceMappingURL=build-legacy-rpc-sdk.js.map